import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import PropertyCard from "@/components/PropertyCard";
import SEO from "@/components/SEO";
import Breadcrumbs from "@/components/Breadcrumbs";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function AgentDetail() {
  const { id } = useParams();
  const [a, setA] = useState(null);
  const [listings, setListings] = useState([]);

  useEffect(() => {
    (async () => {
      const ag = await api.get(`/agents/${id}`);
      setA(ag.data);
      const l = await api.get("/listings");
      setListings(l.data.items.filter((it) => it.agent_id === id));
    })();
  }, [id]);

  if (!a) return <div className="min-h-[60vh] flex items-center justify-center text-neutral-500">Loading…</div>;

  return (
    <div data-testid={`agent-detail-${id}`}>
      <SEO title={a.name} description={a.bio?.slice(0, 160) || `${a.name} — Point Penta Dubai advisor`} path={`/agents/${id}`} image={a.photo_url} />
      <section className="py-16 border-b border-neutral-200">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: "Team", path: "/agents" }, { name: a.name, path: `/agents/${id}` }]} />
        </div>
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            {a.photo_url && <img src={a.photo_url} alt={a.name} className="w-full aspect-[3/4] object-cover" />}
          </div>
          <div className="md:col-span-7">
            <div className="overline text-[#001588] mb-4">{a.role === "founding_partner" ? "Founding Partner" : "Advisor"}</div>
            <h1 className="font-serif text-5xl lg:text-6xl leading-tight mb-6">{a.name}</h1>
            {a.bio && <p className="text-neutral-700 leading-relaxed text-lg mb-6">{a.bio}</p>}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-6 border-t border-neutral-200">
              {a.phone && <Info label="Direct" value={a.phone} />}
              <Info label="Email" value={a.email} />
              {a.languages?.length > 0 && <Info label="Languages" value={a.languages.join(", ")} />}
              {a.specializations?.length > 0 && <Info label="Specialisations" value={a.specializations.join(", ")} />}
            </div>
            <div className="mt-6">
              <WhatsAppButton phone={a.phone} message={`Hi ${a.name.split(" ")[0]}, I'd like to discuss a Dubai property.`} testId={`whatsapp-agent-${id}`} />
            </div>
          </div>
        </div>
      </section>

      {listings.length > 0 && (
        <section className="py-16">
          <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
            <h2 className="font-serif text-4xl mb-10">{a.name.split(" ")[0]}'s current mandates</h2>
            <div className="grid md:grid-cols-3 gap-x-8 gap-y-14">
              {listings.map((p) => <PropertyCard key={p.id} p={p} />)}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div>
      <div className="overline text-neutral-500 mb-1">{label}</div>
      <div className="text-neutral-900">{value}</div>
    </div>
  );
}
